export const globalStyObj = {
  '--Fonts-Font-1': '#333',
  '--Fonts-Font-3': '#b2b2b2',
  '--System-Color-White': '#ffffff',
  '--System-Color-White-All': 'rgba(255, 255, 255, 0.7)',
  '--Card-Card-3': '#fefefe',
  '--Fonts-Font-2': '#666',
  '--Divider-Divider1': '#ededed',
  '--General-Red-All-2': '#f00',
  '--Primary-Color-100': '#a338fc'
}
